import { render, staticRenderFns } from "./ReportConfirm.vue?vue&type=template&id=8d0c1d74"
import script from "./ReportConfirm.vue?vue&type=script&lang=js"
export * from "./ReportConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports